import { Stack, Group, Text, ActionIcon } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { IconCheck } from "@tabler/icons-react";
import { generateTimePresets } from "../../../../../../utils/timePresets";
import { TimePickerWithSmartDropdown } from "../../TimePickerWithSmartDropdown";

function DateTimeSection({
  formData,
  onChange,
  onClose,
  errors,
  validateSection,
}) {
  const timePresets = generateTimePresets();

  const handleClose = () => {
    validateSection("datetime");
    onClose();
  };

  return (
    <Stack p="md">
      {/* Header */}
      <Group w="100%" justify="space-between">
        <Text size="lg" fw={500}>
          Date & Time
        </Text>
        <ActionIcon
          onClick={handleClose}
          variant="subtle"
          color="var(--mantine-color-teal-1)"
        >
          <IconCheck size={20} color="var(--mantine-color-teal-6)" />
        </ActionIcon>
      </Group>

      {/* Date Input */}
      <DateInput
        label="Date"
        required
        value={formData.date}
        onChange={(value) => onChange({ date: value })}
        minDate={new Date()}
        clearable
        placeholder="Select date"
        error={errors.date}
      />

      {/* Start Time Selection */}
      <TimePickerWithSmartDropdown
        label="Start Time"
        value={formData.startTime}
        onChange={(value) => onChange({ startTime: value })}
        minutesStep={15}
        presets={timePresets}
        required
        error={errors.startTime}
      />
    </Stack>
  );
}

export default DateTimeSection;
